<template>
  <div class="loading-screen-container">
    <ProgressLoading />

    <content>
      <header>Updating data</header>
      <footer>It may take up to 3 minutes</footer>
    </content>
  </div>
</template>

<script>
import ProgressLoading from '@/components/ProgressLoading';

export default {
  components: {
    ProgressLoading,
  },

  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.loading-screen-container {
  color: $notBlack;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  content {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    header {
      margin-top: 16px;
      @include h1;
    }

    footer {
      margin-top: 16px;
    }
  }
}
</style>
